import modals from '../../components/modal'

class Leadership {

  constructor(element) {
    this.element = element
    this.teamData = JSON.parse(document.getElementById('TeamMemberData').innerHTML.trim())
    this.blankGif = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';

    this.handleDetailLinkClick = this.handleDetailLinkClick.bind(this)
    this.clearTeamDetails = this.clearTeamDetails.bind(this)
    this.handleModalClose = this.handleModalClose.bind(this)
  }

  handleDetailLinkClick(event) {

    const trigger = event.currentTarget
    const teamUri = trigger.dataset.teamUri

    const teamDetails = this.teamData.find((entry) => entry.uri == teamUri)

    this.setTeamDetails(teamDetails)
    this.modal.open(trigger)
  }

  setTeamDetails(teamDetails) {
    this.modalImageElement.src = teamDetails.image.sizes.large

    let contactLinks = [];

    if (teamDetails.phone_number) {
      contactLinks.push(`<a href="tel:${teamDetails.phone_number.replace(/[^\d]+/, '')}">${teamDetails.phone_number}</a>`)
    }

    if (teamDetails.email_address) {
      contactLinks.push(`<a href="mailto:${teamDetails.email_address}">${teamDetails.email_address}</a>`)
    }

    this.modalContactElement.innerHTML = contactLinks.join(' ')
    this.modalPositionElement.innerHTML = `${teamDetails.organization} ${teamDetails.position}`
    this.modalNameElement.innerHTML = teamDetails.name
    this.modalBioElement.innerHTML = teamDetails.full_bio
  }

  clearTeamDetails() {
    this.modalImageElement.src = this.blankGif
    this.modalContactElement.innerHTML = '';
    this.modalPositionElement.innerHTML = '';
    this.modalNameElement.innerHTML = '';
    this.modalBioElement.innerHTML = '';
  }

  handleModalClose() {
    this.clearTeamDetails()
  }

  init() {
    this.fullVideoContainer = document.getElementById('video-loop-full-embed')
    this.modal = modals.getById('modal-team-bio')
    this.modal.element.addEventListener('close', this.handleModalClose)

    const modalElement = this.modal.element
    this.modalImageElement = modalElement.querySelector('[data-team-image]')
    this.modalContactElement = modalElement.querySelector('[data-team-contact]')
    this.modalPositionElement = modalElement.querySelector('[data-team-position]')
    this.modalNameElement = modalElement.querySelector('[data-team-name]')
    this.modalBioElement = modalElement.querySelector('[data-team-bio]')

    this.element.querySelectorAll('.js-team-detail').forEach((detailLink) => {
      detailLink.addEventListener('click', this.handleDetailLinkClick)
    })
  }
}

export default Leadership
